




import Vue from 'vue';

export default Vue.extend({
  name: 'ConfirmedEmailPage',
  async created() {
      const token = this.$route.query['token'];
      
      if (token) {
        const formData = new FormData();

        formData.append('token', token.toString());

        const request = await this.$store.dispatch('sendConfirmedRegistrationToken', formData);

        if (request.success) {
          window.location.href = '/';
        }
      }
  }
})
